module.exports = __webpack_public_path__ + "img/features-bg.f64a1fa8.svg";